import { Grid } from '@/components/atoms/Grid'
import { FC } from 'react'

const DropdownMenuItemsGrid: FC<Rest> = ({ children, ...rest }) => (
  <Grid minWidth={277} gridRowGap="6px" {...rest}>
    {children}
  </Grid>
)

export default DropdownMenuItemsGrid
